<template>
	<div class="export-popi">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

		<h1>AutoID Check</h1>

		<p class="description">
			This page will check auto id values
		</p>

		<div class="button-container">
			<div class="big-button" @click="check()">
				Check
			</div>
		</div>

		<div v-for="(item, key) of checkResults" :key="key" class="autoid-wrapper">
			<span>{{ item.brand.name }}({{ item.brand.code }})</span>
			<span>{{ item.lastBdCode }}</span>
			<span></span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'exportReturn',
	data: function() {
		return {
			limit: 100,
			isLoading: false,
			brands: [],
			checkResults: []
		}
	},

	watch: {},

	computed: {},

	mounted: async function() {
		await this.getBrands()
	},

	methods: {
		check: async function() {
			this.checkResults = []

			for (const brand of this.brands) {
				const data = {
					brand: brand._id,
					limit: 1,
					sort: {
						bd_code: 'desc'
					}
				}

				const apiResult = await this.$api.getProducts({ data })

				let lastBdCode = 0

				if (apiResult.data.total > 0) {
					lastBdCode = apiResult.data.list[0].bd_code
				}

				const result = {
					brand,
					lastBdCode
				}

				this.checkResults.push(result)
			}
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
